import { fetchApi } from '@/config/axiosSetting';
import { postBodyRejectOrAcceptParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyAcceptOrRejectRecievedImages/postBodyAcceptOrRejectRecievedImages.type';
import { AxiosResponse } from 'axios';

export const postBodyAcceptOrRejectRecievedImagesFunction = (
  params: postBodyRejectOrAcceptParamsType,
): Promise<AxiosResponse<any, any>> => {
  return fetchApi.post(
    `/body/reports/${params.id}/images/corrective/accept_or_reject/`,
    {
      id: params.id,
      ...params.data,
    },
  );
};
